/* hero-banner.js — Suztain hero-modul
   Ansvar: fanebytte, tilstand for overgangene (CSS), og nedtelling.
   Laster som defer. Taaler flere seksjoner paa samme side. */
(function(){
  var REDUSERT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    var stage = root.querySelector('[data-suz-stage]');
    if(!stage) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.suz-slide'));
    slides.forEach(function(s,i){ s.style.setProperty('--i', i); });
    if(slides.length < 2){ requestAnimationFrame(function(){ root.classList.add('is-ready'); }); return; }

    // Autorotasjon er av i temaeditoren. Ellers ville sliden byttet under
    // foettene paa redaktoren midt i en redigering.
    var auto = root.getAttribute('data-suz-auto') === '1'
            && !REDUSERT
            && !(window.Shopify && window.Shopify.designMode);

    root.addEventListener('click', function(e){
      var btn = e.target.closest('[data-suz-go]');
      if(!btn || !root.contains(btn)) return;
      // Manuelt valg nullstiller klokka; autospillet fortsetter etterpaa.
      show(parseInt(btn.getAttribute('data-suz-go'), 10));
    });

    root.addEventListener('keydown', function(e){
      if(!e.target.closest('[data-suz-go]')) return;
      var i = slides.findIndex(function(s){ return s.classList.contains('is-on'); });
      if(e.key === 'ArrowRight'){ show((i+1) % slides.length); e.preventDefault(); }
      if(e.key === 'ArrowLeft'){ show((i-1+slides.length) % slides.length); e.preventDefault(); }
    });

    // Nedtellingen pauser ved mus over, tastaturfokus og skjult fane,
    // saa ingenting bytter mens kunden leser eller er borte.
    var over = false, fokus = false;
    function pauseSjekk(){ root.classList.toggle('is-paused', over || fokus || document.hidden); }
    root.addEventListener('mouseenter', function(){ over = true; pauseSjekk(); });
    root.addEventListener('mouseleave', function(){ over = false; pauseSjekk(); });
    root.addEventListener('focusin', function(){ fokus = true; pauseSjekk(); });
    root.addEventListener('focusout', function(){ fokus = false; pauseSjekk(); });
    document.addEventListener('visibilitychange', pauseSjekk);

    // Fyllet i fanen ER nedtellingen. Naar animasjonen er ferdig, bytter
    // vi slide. Da kan strek og bytte aldri komme i utakt.
    root.addEventListener('animationend', function(e){
      if(!auto) return;
      if(!e.target.classList || !e.target.classList.contains('suz-tab__bar')) return;
      var vises = stage.querySelector('.suz-slide.is-on');
      if(!vises || !vises.contains(e.target)) return;   // ignorer skjulte slides
      var i = slides.indexOf(vises);
      show((i+1) % slides.length);
    });

    function tell(){
      if(!auto) return;
      var vises = stage.querySelector('.suz-slide.is-on');
      if(!vises) return;
      var tab = vises.querySelector('.suz-tab[aria-selected="true"]');
      if(!tab) return;
      tab.classList.remove('is-timing');
      void tab.offsetWidth;                  // tving restart av animasjonen
      tab.classList.add('is-timing');
    }

    function show(n){
      // Overgangen ligger i CSS (suz-hero--tr-*). Her settes bare tilstand:
      // is-on, --cur for sveip-sporet, og inert saa skjulte slides ikke
      // kan klikkes eller tabbes til.
      root.style.setProperty('--cur', n);
      slides.forEach(function(s,i){
        s.classList.toggle('is-on', i===n);
        if(i===n) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      root.querySelectorAll('[data-suz-go]').forEach(function(b){
        var valgt = parseInt(b.getAttribute('data-suz-go'),10) === n;
        b.setAttribute('aria-selected', String(valgt));
        if(!valgt) b.classList.remove('is-timing');
      });
      tell();
    }

    // Hoyden laases ikke lenger i JS: slidene ligger stablet i samme
    // grid-celle, saa scenen faar automatisk hoyden til den hoyeste.
    // Reserven over knappen ligger i CSS, saa den gjelder allerede ved
    // forste maling og koster ingen CLS. Skriver redaktoren lengre tekst
    // enn reserven, hever vi den her - ellers begynner knappen aa hoppe
    // mellom slidene igjen. Vi senker den aldri, bare hever.
    function reserver(){
      var tops = slides.map(function(s){ return s.querySelector('.suz-top'); }).filter(Boolean);
      if(!tops.length) return;
      tops.forEach(function(t){ t.style.minHeight = ''; });
      // Bare desktop. Paa mobil koster en fast reserve mer enn den gir:
      // knappen havner under skjermkanten.
      if(!window.matchMedia('(min-width:900px)').matches) return;
      var basis = parseFloat(getComputedStyle(tops[0]).minHeight) || 0;
      // Skjulte slides har fortsatt layout (visibility, ikke display),
      // saa de kan maales direkte. Aa toggle is-on her ville utlost en fade.
      var maks = 0;
      tops.forEach(function(t){ maks = Math.max(maks, t.offsetHeight); });
      if(maks > basis) tops.forEach(function(t){ t.style.minHeight = maks + 'px'; });
    }
    var start = slides.findIndex(function(s){ return s.classList.contains('is-on'); });
    root.style.setProperty('--cur', start < 0 ? 0 : start);
    slides.forEach(function(s,i){ if(i !== start) s.setAttribute('inert', ''); });
    reserver();
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(reserver);
    addEventListener('resize', debounce(reserver, 150));
    root.__suzShow = show;
    pauseSjekk();
    // Forste slide skal bare staa der. Overgangene slaas paa i neste
    // animasjonsramme, etter at startbildet er tegnet.
    requestAnimationFrame(function(){ root.classList.add('is-ready'); });
    tell();
  }

  function debounce(fn, ms){ var t; return function(){ clearTimeout(t); t = setTimeout(fn, ms); }; }

  function boot(){ document.querySelectorAll('[data-suz-hero]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('[data-suz-hero]').forEach(init);
  });
  // Velger redaktoren en slide i temaeditoren, skal den slaas paa.
  // Uten dette kan man redigere slide 2 mens slide 1 staar synlig.
  document.addEventListener('shopify:block:select', function(e){
    var slide = e.target.closest ? e.target.closest('.suz-slide') : null;
    if(!slide) return;
    var root = slide.closest('[data-suz-hero]');
    if(!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.suz-slide'));
    var n = slides.indexOf(slide);
    if(n < 0 || !root.__suzShow) return;
    root.__suzShow(n);
  });
})();
